import { SlotGameType1_21 } from '../SlotGameType1_21';

export class LuckyFire1021 extends SlotGameType1_21
{
}
